import { makeStyles } from '../../styles/themes/themewrapper';

export const useCustomStyles = makeStyles<{ flexDirection: 'column' | 'row' }>()((theme, props) => ({
	container: {
		display: 'flex',
		flexDirection: props.flexDirection,
		gap: theme.spacing.xxsmall,
	},
	inclusive: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.xxsmall,
	},
}));
